import { acDashboardTypes } from '../acReduxExports';

const dashboardInitialState: AcDashboardState = {
  dashboardHeaderLoader: false,
  newDashboardHeaderData:null,
  newDashboardHeaderFilterHsah: null,
  newDashboardAlarmSummaryFilterHash:null,
  newDashboardAlarmSummaryInfo:null,
  newDashboardAlarmSummaryTableLoader: false,
  newDashboardRealtimeGunInfoFilterHash: null,
  newDashboardRealTimeGunsInfo: null,
  newDashboardChargingSessionFilterHash: null,
  newDashboardChargingSessionsInfo: null,
  newDashboardChargingSessionsStats:null,
  newDashboardConnectivityFilterHash: null,
  newDashboardConnectivityMediumData: null,
  customerWiseChargerHealthGraphLoader:false,
  newDashboardCharginsSessionTrendFilterHash: null,
  newDashboardChargingSessionTrendInfo: null,
  newDashboardEnergyTrendFilterHash: null,
  newDashboardEnergyTrendInfo: null,
  newDashboardChargingVsIdleFilterHash: null,
  newDashboardChargingVsIdleInfo: null,
  newDashboardAttentionRequiredFilterHash: null,
  newDashboardAttentionRequiredInfo: null,
  newDashboardOverallUptimeFilterHash: null,
  newDashboardOverallUptimeInfo: null
};

const acdashboardReducer = (
  state: AcDashboardState = dashboardInitialState,
  action: AcDashboardAction
): AcDashboardState => {
  switch (action.type) {
    case acDashboardTypes.FETCH_AC_NEW_DASHBOARD_HEADER_DATA:
          return {
            ...state,
            newDashboardHeaderData: action.newDashboardHeaderData,
          };
    case acDashboardTypes.SET_AC_DASHBOARD_STATE_DATA:
          return { 
            ...state,
            ...action
          }
    case acDashboardTypes.FETCH_AC_NEW_DASHBOARD_REAL_TIME_GUN_INFO:
          return {
            ...state,
            newDashboardRealTimeGunsInfo: action.newDashboardRealTimeGunsInfo,
          };
    case acDashboardTypes.SET_NEW_DASHBOARD_AC_CHARGING_SESSION_FILTER_HASH:
          return {
            ...state,
            newDashboardChargingSessionFilterHash: action.newDashboardChargingSessionFilterHash
          }
    case acDashboardTypes.FETCH_NEW_AC_CHARGING_SESSIONS_INFO:
          return {
            ...state,
            newDashboardChargingSessionsInfo: action.newDashboardChargingSessionsInfo,
            newDashboardChargingSessionsStats: action.newDashboardChargingSessionsStats,
          };
    case acDashboardTypes.SET_NEW_AC_DASHBOARD_CONNECTIVITY_MEDIUM_FILTER_HASH: 
          return {
            ...state,
            newDashboardConnectivityFilterHash: action.newDashboardConnectivityFilterHash
          }
    case acDashboardTypes.FETCH_NEW_AC_DASHBOARD_CONNECTIVITY_MEDIUM_DATA:
          return {
            ...state,
            newDashboardConnectivityMediumData: action.newDashboardConnectivityMediumData,
          };

    case acDashboardTypes.SET_AC_CHARGING_SESSION_TREND_FILTER_HASH: 
          return {
            ...state,
            newDashboardCharginsSessionTrendFilterHash: action.newDashboardCharginsSessionTrendFilterHash
          }
    case acDashboardTypes.FETCH_NEW_AC_DASHBOARD_CHARGING_SESSION_TRENDS_INFO:
          return {
            ...state,
            newDashboardChargingSessionTrendInfo: action.newDashboardChargingSessionTrendInfo,
          };

    case acDashboardTypes.SET_NEW_AC_DASHDOARD_ENERGY_TREND_FILTER_HASH:
          return {
            ...state,
            newDashboardEnergyTrendFilterHash: action.newDashboardEnergyTrendFilterHash
          }

    case acDashboardTypes.FETCH_NEW_AC_DASHBOARD_ENERGY_TREND_INFO:
          return {
            ...state,
            newDashboardEnergyTrendInfo: action.newDashboardEnergyTrendInfo,
          };
    case acDashboardTypes.SET_AC_DASHBOARD_CHARGING_VS_IDLE_FILTER_HASH:
          return {
            ...state,
            newDashboardChargingVsIdleFilterHash: action.newDashboardChargingVsIdleFilterHash
          }
    case acDashboardTypes.FETCH_AC_NEW_DASHBOARD_CHARGING_VS_IDLE_INFO:
          return {
            ...state,
            newDashboardChargingVsIdleInfo: action.newDashboardChargingVsIdleInfo,
          };
    case acDashboardTypes.SET_AC_ATTENTION_REQUIRED_FILTER_HASH:
          return {
            ...state,
            newDashboardAttentionRequiredFilterHash: action.newDashboardAttentionRequiredFilterHash
          };
    case acDashboardTypes.FETCH_AC_NEW_DASHBOARD_ATTENTION_REQUIRED_DATA:
          return {
            ...state,
            newDashboardAttentionRequiredInfo: action.newDashboardAttentionRequiredInfo,
          };
    case acDashboardTypes.SET_AC_DASHBOARD_OVERALL_UPTIME_FILTER_HASH:
          return {
            ...state,
            newDashboardOverallUptimeFilterHash: action.newDashboardOverallUptimeFilterHash
          };
    case acDashboardTypes.FETCH_AC_NEW_DASHBOARD_OVERALL_UPTIME_INFO:
          return {
            ...state,
            newDashboardOverallUptimeInfo: action.newDashboardOverallUptimeInfo,
          };
    default:
      return state;
  }
};

export default acdashboardReducer;
